import { render } from "./SidenavListV2.vue?vue&type=template&id=ad7e5894"
import script from "./SidenavListV2.vue?vue&type=script&lang=js"
export * from "./SidenavListV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__